import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ConfProyecto, SplashScreenService } from '@copec-gid/gid-arquitectura.utilitarios-base-modulo-a16';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = ConfProyecto.nombreAplicacion;
  public opacityChange = 0;
  loaderLogo = "/assets/images/logo-mini-md.png"
  public splashTransition: any;
  // First access the splash is visible
  public showSplash = false;
  public splashdisplay = "none";
  public loaderMessage: string = "";


  constructor(
    private splashScreenStateService: SplashScreenService,
    private ref: ChangeDetectorRef,
  ) {

  }

  readonly ANIMATION_DURATION = 1;


  ngOnInit(): void {
    this.splashScreenStateService.ocultar(() => {
      this.hideSplashAnimation();
    });

    this.splashScreenStateService.mostrar((res: any) => {
      this.loaderMessage = res;
      this.showSplashAnimation();
    });
  }

  private showSplashAnimation() {
    this.splashTransition = `opacity ${this.ANIMATION_DURATION}s`;
    this.opacityChange = 1;
    this.showSplash = true;
    this.splashdisplay = "flex"

    setTimeout(() => {
      this.ref.detectChanges()
    }, 50);

  }

  private hideSplashAnimation() {
    // Setting the transition


    // After the transition is ended the showSplash will be hided
    this.splashTransition = `opacity ${this.ANIMATION_DURATION}s`;
    this.opacityChange = 0;
    this.splashdisplay = "none"
    this.showSplash = false;
    setTimeout(() => {
      this.ref.detectChanges()
    }, 50);


  }

}
